import { default as browse_45topicyPJ1syiNwMMeta } from "/code/pages/browse/browse-topic.vue?macro=true";
import { default as indexCLit7sRKlPMeta } from "/code/pages/browse/index.vue?macro=true";
import { default as _91slug_93qaNm4HpskPMeta } from "/code/pages/browse/shows/[slug].vue?macro=true";
import { default as _91slug_93qogmdE5KqZMeta } from "/code/pages/browse/shows/episode/[slug].vue?macro=true";
import { default as confirmbA8LHwMBMBMeta } from "/code/pages/confirm.vue?macro=true";
import { default as homeX8uzRDotlsMeta } from "/code/pages/home.vue?macro=true";
import { default as indexKRDw4UYEiPMeta } from "/code/pages/index.vue?macro=true";
import { default as live5mbVcPZwkPMeta } from "/code/pages/live.vue?macro=true";
import { default as loginT5FXYAtKoAMeta } from "/code/pages/login.vue?macro=true";
import { default as _91slug_93KXvC9j0528Meta } from "/code/pages/npr/[slug].vue?macro=true";
import { default as _91slug_93TrDGnZxpOuMeta } from "/code/pages/people/[slug].vue?macro=true";
import { default as privacyGRokESy9tcMeta } from "/code/pages/privacy.vue?macro=true";
import { default as saved4f9zwGHMNIMeta } from "/code/pages/saved.vue?macro=true";
import { default as signup8HRXv4VtmlMeta } from "/code/pages/signup.vue?macro=true";
import { default as _91slug_931e6Q4Y4DS0Meta } from "/code/pages/staff/[slug].vue?macro=true";
import { default as _91slug_93WE0AkHGwJjMeta } from "/code/pages/story/[slug].vue?macro=true";
import { default as _91gallerySlug_9301CAhoaNksMeta } from "/code/pages/story/photos/[gallerySlug].vue?macro=true";
import { default as termsEzIw6jSVmbMeta } from "/code/pages/terms.vue?macro=true";
import { default as test_45routeeIfn1udBV6Meta } from "/code/pages/test-route.vue?macro=true";
export default [
  {
    name: "browse-browse-topic",
    path: "/browse/browse-topic",
    component: () => import("/code/pages/browse/browse-topic.vue").then(m => m.default || m)
  },
  {
    name: "browse",
    path: "/browse",
    component: () => import("/code/pages/browse/index.vue").then(m => m.default || m)
  },
  {
    name: "browse-shows-slug",
    path: "/browse/shows/:slug()",
    component: () => import("/code/pages/browse/shows/[slug].vue").then(m => m.default || m)
  },
  {
    name: "browse-shows-episode-slug",
    path: "/browse/shows/episode/:slug()",
    component: () => import("/code/pages/browse/shows/episode/[slug].vue").then(m => m.default || m)
  },
  {
    name: "confirm",
    path: "/confirm",
    meta: confirmbA8LHwMBMBMeta || {},
    component: () => import("/code/pages/confirm.vue").then(m => m.default || m)
  },
  {
    name: "home",
    path: "/home",
    meta: homeX8uzRDotlsMeta || {},
    component: () => import("/code/pages/home.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: indexKRDw4UYEiPMeta || {},
    component: () => import("/code/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "live",
    path: "/live",
    component: () => import("/code/pages/live.vue").then(m => m.default || m)
  },
  {
    name: "login",
    path: "/login",
    meta: loginT5FXYAtKoAMeta || {},
    component: () => import("/code/pages/login.vue").then(m => m.default || m)
  },
  {
    name: "npr-slug",
    path: "/npr/:slug()",
    component: () => import("/code/pages/npr/[slug].vue").then(m => m.default || m)
  },
  {
    name: "people-slug",
    path: "/people/:slug()",
    component: () => import("/code/pages/people/[slug].vue").then(m => m.default || m)
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/code/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: "saved",
    path: "/saved",
    component: () => import("/code/pages/saved.vue").then(m => m.default || m)
  },
  {
    name: "signup",
    path: "/signup",
    meta: signup8HRXv4VtmlMeta || {},
    component: () => import("/code/pages/signup.vue").then(m => m.default || m)
  },
  {
    name: "staff-slug",
    path: "/staff/:slug()",
    component: () => import("/code/pages/staff/[slug].vue").then(m => m.default || m)
  },
  {
    name: "story-slug",
    path: "/story/:slug()",
    component: () => import("/code/pages/story/[slug].vue").then(m => m.default || m)
  },
  {
    name: "story-photos-gallerySlug",
    path: "/story/photos/:gallerySlug()",
    component: () => import("/code/pages/story/photos/[gallerySlug].vue").then(m => m.default || m)
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/code/pages/terms.vue").then(m => m.default || m)
  },
  {
    name: "test-route",
    path: "/test-route",
    component: () => import("/code/pages/test-route.vue").then(m => m.default || m)
  }
]